var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide-phone"},[_c('InputPhone',{on:{"input":function($event){_vm.phone = $event}}}),_c('Button',{attrs:{"disabled":_vm.typePage === 'register' ? (!_vm.accessPolitic || !_vm.phone) : !_vm.phone,"text":"Получить код по смс"},on:{"click":function($event){return _vm.checkPhone()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }